import ButtonSubmit from './ButtonSubmit.wrapper';
import { IButtonSubmit } from './ButtonSubmit.interfaces';

export default ButtonSubmit;
export { ButtonSubmit, IButtonSubmit };
